import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qqbr958t4u: FaireBrandEntity = {
  token: "b_qqbr958t4u",
  type: "brand",
  name: "My Wholesale Gifts",
  avatarUrl:
    "https://cdn.faire.com/fastly/a636877931e31fd6aa588b930a8aa4adda5e82c133d8a1f0606defbc1106fc3a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c2a5b0dbfef97bf7effc340e9dab94a54bf8d837a168074814925f571f9cddf1.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/a636877931e31fd6aa588b930a8aa4adda5e82c133d8a1f0606defbc1106fc3a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c2a5b0dbfef97bf7effc340e9dab94a54bf8d837a168074814925f571f9cddf1.webp",
  location: "Sumner, WA, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Mywholesalegifts is  one of leading Wholesale Distribution companies in the Giftware and Home Decor marketplace. Buy wholesale and save on home decor today at cheap discount prices.  ",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:49.893Z",
    importedBy: "entity-db-cli",
  },
};
